/**
 * @file
 * A JavaScript file for Anchor Platform logged in user.
 *
 */

"use strict";

var
	delay = 500,
	isLoading = false,
	isDone = true,
	modal,
	unCodes,
	hsCodes,
	shippingLine,
	releaseDepots,
	terminals,
	filters = [],
	stepCount = 1,
	lastStep = 0
;

(function($, Drupal) {

	Drupal.behaviors.hideRefrigerations = {
	  attach: function (context, settings) {
			// Hide the refrigeration group on the Field collection
			var $containerWrapper = $('.field-name-field-container-types.field-widget-field-collection-embed table.field-multiple-table tbody > tr.draggable')
			if ($containerWrapper.length) {
				$containerWrapper.once('hideRefrigerations', function(index) {
					var $toHide = $('.group-refrigerator-group', this);
					var $select = $('.field-name-field-container-size select', this);
					// On collection load
					$select.val().indexOf('RF') > 0 ? $toHide.show() : $toHide.hide();
					// On Select change
					$select.change( function() {
						if ( $(this).val().indexOf('RF') > 0 ) {
              $toHide.slideDown();
            } else {
              $toHide.slideUp();
              // Reset all inputs at once
              $('input', $toHide).attr('checked', false).val('');
            }
					});
				});
			}
	  }
	};

	Drupal.behaviors.referenceLabel = {
		attach: function (context, settings) {
			// No browser autocomplete for booking form
			$('form.node-anchor_booking-form').attr('autocomplete', 'off');
			// Change the label for Shipper ref
			$('#edit-field-shipper-reference-no- .field-add-more-submit').text('Add another ref');
			$('#edit-field-shipper-reference-no- .field-add-more-submit').val('Add another ref');
			// Change the label for Containers Type
			$('[name="field_container_types_add_more"]').val('Add another container');
		}
	};

	$(document).ready(function() {
		hamburger();
		modalOpen();
		expander();
		dropMenu();
		searchTextInput();
		get_autocomplete_group();
		// stickyHeader();
		dragDrop();
		showHideFormOptions();
		bookingMobileMenu();
		messageModal();
		saveClickMobile();
		disableSubmitButton();
		showChangeBox();
		showFilterIfSelected();
		dashboardMenuTrail();
		closeUploadBoxError();
		addPlaceholderText();
		init_filters();
		getTerminalName();
		saveAndSend();
		sendToInttra();
		approvedOrAmmendments();

		formHasFiles();
		addBlankToSteps();

		hideBob();
		requiredFieldValidation();

		$('.file a').attr('target', '_blank');

		if (
			$('body.page-field-collection-field--invoices-').length &&
			!$('body.page-field-collection-field--invoices-edit').length
		) {
			triggerInvoiceSend();
			triggerInvoiceSendAll();
		}

		if ($('body.page-field-collection-field--invoices-edit').length) {
			removeInvoiceCheck();
		}

		function removeInvoiceCheck() {
			const triggers = document.querySelectorAll('.field-name-field-invoice .file-widget input[value="Remove"], .field-name-field-invoice .file-widget input[type="File"]')

			if (triggers.length > 0) {
				Object.entries(triggers).forEach(([_, el]) => {
					on(el, 'mousedown', (e) => {
						console.log(el)
						el.closest('.fieldset-wrapper').querySelector('.form-checkbox').checked = false
					})
				})
			}
		}

		function triggerInvoiceSend() {
			const triggers = document.querySelectorAll('.send-invoice')
			if (triggers.length > 0) {
				Object.entries(triggers).forEach(([_, el]) => {
					on(el, 'click', (e) => {
						e.preventDefault()
						const invoiceId = window.location.pathname.match(/\d+/g)[0]
						
						// Find the uploaded invoices
						let files = []
						let fids = []
						let fcids = [el.closest('.field-collection-item-field-invoice').attributes.about.value.match(/\d+/g)[0]]
						let invoices = el.parentNode.querySelectorAll('.file a')
						let fiddata = el.parentNode.querySelectorAll('.send-invoice')
						let sending = ''

						Object.entries(invoices).forEach(([_, invoice]) => {
							files.push(invoice.href)
						})

						Object.entries(fiddata).forEach(([_, fid]) => {
							fids.push(fid.dataset.fid)
						})

						if (el.classList.contains('send-usd')) {
							sending = 'usd'						
						} else if (el.classList.contains('send-aud')) {
							sending = 'aud'
						} else if (el.classList.contains('send-both')) {
							sending = 'both'						
						}

						if (invoices.length > 0) {
							const namesCheckboxes = document.getElementById('invoice-users').querySelectorAll('input[type="checkbox"]')
							let names = []

							Object.entries(namesCheckboxes).forEach(([_, name]) => {
								if (name.checked) names.push(name.dataset.uid)
							})

							if (names.length > 0) {
								document.body.classList.add('modal-open-invoice')

								on(document.getElementById('modal-send-cancel'), 'click', (e) => {
									e.preventDefault()
									document.body.classList.remove('modal-open-invoice')
								})

								on(document.getElementById('modal-send'), 'click', (e) => {
									e.preventDefault()

									let data = {
										files: files,
										fids: fids,
										fcids: fcids,
										names: names,
										sending: sending,
										invoiceId: invoiceId,
										message: document.getElementById('notification-message').value
									}
									
									let formData = ''
									formData = new FormData()
									formData.append('data', JSON.stringify(data))

									fetch('/send/invoices', {
										method: 'POST',
										body: formData
									})
										.then((res) => res.json())
										.then((resdata) => {
											console.log(resdata)
											document.body.classList.remove('modal-open-invoice')
											location.reload()
										})
										.catch((error) => console.log(error))
								})
							} else {
								alert('You must select a user to send emails to.')
							}
						} else {
							alert('You must have saved invoices to send.')
						}
					})
				})
			}
		}

		function triggerInvoiceSendAll() {
			const button = document.getElementById('send-all-invoices')

			on(button, 'click', (e) => {
				e.preventDefault()
				const invoiceId = window.location.pathname.match(/\d+/g)[0]
						
				// Find the uploaded invoices
				let files = []
				let fids = []
				let fcids = []
				let invoices = document.querySelectorAll('.field-name-field-invoice .file a')
				let fiddata = document.querySelectorAll('.field-name-field-invoice .send-invoice')

				Object.entries(invoices).forEach(([_, invoice]) => {
					files.push(invoice.href)
				})

				Object.entries(fiddata).forEach(([_, fid]) => {
					fids.push(fid.dataset.fid)
				})

				Object.entries(document.querySelectorAll('.field-collection-item-field-invoice')).forEach(([_, fcid]) => {
					fcids.push(fcid.attributes.about.value.match(/\d+/g)[0])
				})

				if (invoices.length > 0) {
					const namesCheckboxes = document.getElementById('invoice-users').querySelectorAll('input[type="checkbox"]')
					let names = []

					Object.entries(namesCheckboxes).forEach(([_, name]) => {
						if (name.checked) names.push(name.dataset.uid)
					})

					if (names.length > 0) {
						document.body.classList.add('modal-open-invoice')

						on(document.getElementById('modal-send-cancel'), 'click', (e) => {
							e.preventDefault()
							document.body.classList.remove('modal-open-invoice')
						})

						on(document.getElementById('modal-invoice-close'), 'click', (e) => {
							e.preventDefault()
							document.body.classList.remove('modal-open-invoice')
						})

						on(document.getElementById('modal-send'), 'click', (e) => {
							e.preventDefault()

							let data = {
								files: files,
								fids: fids,
								fcids: fcids,
								names: names,
								sending: 'all',
								invoiceId: invoiceId,
								message: document.getElementById('notification-message').value
							}

							let formDataAll = ''
							formDataAll = new FormData()
							formDataAll.append('data', JSON.stringify(data))

							fetch('/send/invoices', {
								method: 'POST',
								body: formDataAll
							})
								.then((res) => res.json())
								.then((resdata) => {
									console.log(resdata)
									document.body.classList.remove('modal-open-invoice')
									location.reload()
								})
								.catch((error) => console.log(error))
						})
					} else {
						alert('You must select a user to send emails to.')
					}
				} else {
					alert('You must have saved invoices to send.')
				}
			})
		}

		initialCheckForATD();
		function initialCheckForATD() {
			if ( $('.oneStopATD').length ) {
				$('.oneStopATD').hide();
				var el = document.getElementById('edit-field-port-of-load-pol-und-0-value');
				one_stop_filter('onload', el);
			}
		}

		polUpdate();
		tsUpdate();
		podUpdate();
		fdUpdate();

		function polUpdate() {
			if ( $('#edit-field-port-of-load-pol-und-0-value').length ) {
				$('<input id="polName" class="text-full form-text generated" readonly="readonly" type="text" />').insertAfter('#edit-field-port-of-load-pol-');
				updatePorts('polUpdate', $('#edit-field-port-of-load-pol-und-0-value'));

				$('#edit-field-port-of-load-pol-und-0-value').on('change', () => {
					updatePorts('polUpdate', $('#edit-field-port-of-load-pol-und-0-value'));
				})
			}
		}

		function tsUpdate() {
			if ( $('#edit-field-transhipment-port-t-s-und').length ) {
				$('<input id="tsCode" class="text-full form-text generated" readonly="readonly" type="text" />').insertAfter('#edit-field-transhipment-port-t-s-und');
				updatePorts('tsUpdate', $('#edit-field-transhipment-port-t-s-und'));

				$('#edit-field-transhipment-port-t-s-und').on('change', () => {
					updatePorts('tsUpdate', $('#edit-field-transhipment-port-t-s-und'));
				})
			}
		}

		function podUpdate() {
			if ( $('#edit-field-port-of-discharge-pod-und').length ) {
				$('<input id="podCode" class="text-full form-text generated" readonly="readonly" type="text" />').insertAfter('#edit-field-port-of-discharge-pod-und');
				updatePorts('podUpdate', $('#edit-field-port-of-discharge-pod-und'));

				$('#edit-field-port-of-discharge-pod-und').on('change', () => {
					updatePorts('podUpdate', $('#edit-field-port-of-discharge-pod-und'));
				})
			}
		}

		function fdUpdate() {
			if ( $('#edit-field-final-destination-und').length ) {
				$('<input id="fdCode" class="text-full form-text generated" readonly="readonly" type="text" />').insertAfter('#edit-field-final-destination-und');
				updatePorts('fdUpdate', $('#edit-field-final-destination-und'));

				$('#edit-field-final-destination-und').on('change', () => {
					updatePorts('fdUpdate', $('#edit-field-final-destination-und'));
				})
			}
		}

		function requiredFieldValidation() {
			var isValid = true;
			$('form .required').each(function() {
				if ( $(this).val() == '' || $(this).val() == '_none' ) {
					isValid = false;
				}
			});

			if( !isValid ) {
				$('.form-submit, .event-save-send').prop('disabled', true);
			} else {
				$('.form-submit, .event-save-send').prop('disabled', false);
			}
		}

		$('form .required').on('keyup blur change', function() {
			requiredFieldValidation();
		});

		function hideBob() {
			if ( $('.form-type-checkbox').length ) {
				$('.form-type-checkbox').each( function() {
					var current = $(this);
					var text = current.text();
					
					if ( text.includes("Bob Brittles")) {
						current.remove()
					}
				})
			}
		}

		function addBlankToSteps() {
			$('.group-step-2 span.file a').attr('target','_blank');
			$('.group-step-4 span.file a').attr('target','_blank');
		}

		function formHasFiles() {
			if ( $('body.page-field-collection-field--invoices-edit, body.page-field-collection-field--invoices-add').length ) {
				$('.file-widget').each( function() {
					if ( $(this).find('.form-file').length ) {
						$(this).parent().addClass('no-file');

						$(this).parent().parent().parent().next('div[class$="-status"],div[class*="-status "]').find('input.form-radio:checked').each( function() {
							$(this).prop('checked', false);
						});
					} else {
						var classAdder = $(this).parent();
						$(classAdder).addClass('not-selected');
						$(this).parent().parent().parent().next('div[class$="-status"],div[class*="-status "]').find('input.form-radio:checked').each( function() {
							if ( $(this).val() == 'outstanding' ) {
								$(classAdder).removeClass('not-selected, paid');
								$(classAdder).addClass('outstanding');
							} else if ( $(this).val() == 'paid' ) {
								$(classAdder).removeClass('not-selected, outstanding');
								$(classAdder).addClass('paid');
							}
						});
					}
				});
			}

			if ( $('body.page-field-collection-field-documentation-edit, body.page-field-collection-field-documentation-add').length ) {
				$('.file-widget').each( function() {
					$('.ajax-new-content').parent().parent().removeClass('no-file');
					if ( $(this).find('.form-file').length ) {
						$(this).parent().parent().parent().addClass('no-file');
					}
				});
			}
		}

		$('input.form-radio').on('click', function() {
			formHasFiles();
		});

		$('input.step4AttachCalc-processed').on('click', function() {
			approvedOrAmmendments();
		});

		function approvedOrAmmendments() {
			$('input.step4AttachCalc-processed:checked').each( function() {
				if( $(this).val() == 0 || $(this).val() == '0' ) {
					$(this).closest('tr').addClass('step4-ammendments');
					$(this).closest('tr').removeClass('step4-approved');
				} 
				if( $(this).val() == 1 || $(this).val() == '1' ) {
					$(this).closest('tr').removeClass('step4-ammendments');
					$(this).closest('tr').addClass('step4-approved');
				} 
			});
		}

		$('.field-name-field-step-4-file-status').find('.description').on('click', function() {
			$(this).prev('div').find('input.form-radio[value="_none"]').click();
		});

		$( document ).ajaxComplete( function() {
			formHasFiles();
			addPlaceholderText();
		});

		// Translate the Value of termianls
		function getTerminalName() {
			var $terminalCode = $("#edit-field-return-terminal-und-0-value");
			var $terminalName = $('#edit-field-return-terminal-name-und-0-value');
			// On load
			if ( $terminalCode.length && $terminalCode.val() ) {
				$.get( "/get/terminalname/" + $terminalCode.val(), function( data ) {
					$terminalName.val(data);
				});
			}
			// On change
			$terminalCode.on('change paste keyup', function() {
				// reset the value regardless
				$terminalName.val('');
				// if not empty, perform an ajax request
				if ( $terminalCode.val() ) {
					$.get( "/get/terminalname/" + $(this).val(), function( data ) {
						// If the code matches a name, print it
						$terminalName.val(data);
					}).fail(function() {
						// Otherwise add a placeholder (value is actually empty)
						$terminalName.attr('placeholder', 'Not found');
				  })
				}
			});
		}

		// Save and send behaviour
		function saveAndSend() {
			var $saveSend = $('input.event-save-send');
			$saveSend.click( function(e) {

				// e.preventDefault();
				var $sendMail = $("input#edit-field-send-mail-und");
				var $save = $('.form-actions input#edit-submit--2');
				$sendMail.prop('checked', true);

				// Get the Names to notify
				var $names = $('#edit-field-customer-who-receives-book-und input:checked');
				var emailNames = '';
				$names.each( function () {
					var name = $(this).siblings('label').text().trim();
					if ( name ) {
						if ( emailNames.length > 0 ) emailNames += ', ';
						emailNames += name;
					}
				});

				// Get the ShipRefNo as comma sep list as subject
				var $refs = $('input[id^="edit-field-shipper-reference-no"].form-text');
				var anchorBookingNo = $('#aside-container-bookings h1').text();
				var clientBookingNo = $('#edit-field-shipping-line-reference-no-und-0-value').val();
				var subject = 'Anchor booking - '+clientBookingNo+' - '+anchorBookingNo;
				var i = 0;
				$refs.each( function () {
					if ( $(this).val() ) {
						subject += (i === 0) ? ' - ' : ', ';
						subject += $(this).val();
					}
					i++;
				});

				// Binding Behaviour for modal send
				// Close Modal
				$('#anchorModal .modal-content').on('click', '#modal-send-cancel', function() {
					$('.modal-close').click();
				});

				// Attach log and Send
				$('#anchorModal .modal-content').on('click', '#modal-send', function() {

					// Reset errors
					$('#notification-email').removeClass('error');
					$('#notification-message').removeClass('error');

					// Get values
					var message = $('#notification-message').val().trim();

					// Verify and send
					if ( emailNames && message ) {
						var $newLog = $('table#field-mail-log-values > tbody > tr:last-of-type');
						$('.field-name-field-email input', $newLog).val(emailNames);
						$('.field-name-field-subject input', $newLog).val(subject);
						$('.field-name-field-message textarea', $newLog).val(message);
						// Copy the message on the booking log
						$('.node-form-revision-information textarea').val('Email to ' + emailNames + ': ' + message);
						// Save and close modal
						$save.click();
						$('.modal-close').click();
					} else {
						// Verification failed
						if (!emailNames) $('#notification-email').addClass('error').attr('placeholder', 'Please select at least one contact');
						if (!message) $('#notification-message').addClass('error').attr('placeholder', 'Please type in a message');;
					}

				});

				// The form itself
				var html = '';
				html += '<h2>Send Notification</h2>';
				html += '<div class="input-wrapper form-item"><input type="email" id="notification-email" class="form-text" placeholder="Users who receive the notification" value="' + emailNames + '" readonly><label for="contact-email">Users who receive the notification</label></div>';
				html += '<div class="input-wrapper form-item"><input type="text" id="notification-subject" class="form-text" placeholder="Subject" value="' + subject + '" readonly ><label for="notification-subject">Subject</label></div>';
				html += '<div class="input-wrapper form-item"><textarea id="notification-message" rows="5" cols="90" class="form-textarea" placeholder="Message"></textarea><label for="notification-message">Message</label></div>';
				html += '<div class="input-wrapper form-item">';
				html += '<button id="modal-send-cancel" class="btn secondary">Cancel</button> ';
				html += '<button id="modal-send" class="btn">Send</button></div>';

				// Attach the form and open Modal
				$(".modal-content").addClass('modal--save-and-send').html(html);
				$("body").addClass("modal-open");

			});
		}

		function sendToInttra() {
			if ( $('button.event-send-to-inttra').length ) {
				const $sendInttra = $('button.event-send-to-inttra')
				const main = document.getElementById('main')

				if ( !$sendInttra.hasClass('disabled') ) {				
					$sendInttra.click( function(e) {
						e.currentTarget.classList.add('throbber')

						if ( main.dataset.nid ) {
							$().customAjax({
								TYPE: 'POST',
								AJAX_URL: Drupal.settings.basePath + 'inttra/booking-request/' + main.dataset.nid,
								beforeSend: function() {
								},
								success: function(data) {
									if (data.success) {
										// $sendInttra.removeClass('throbber')
										location.reload()
									}
									if (data.error) {
										console.log('error1')
									}
								},
								error: function(data) {
									console.log(data)
									if (data.error) {
										console.log('error2')
										return
									}								
								}
							})
						}
					})
				}
			}
		}

		function validateEmail(email) {
		    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		    return re.test(String(email).toLowerCase());
		}

		function addPlaceholderText() {
			if ($('.form-type-date-popup').length) {
				$(".form-type-date-popup input[name*='date']").attr("placeholder", "DD/MM/YYYY");
				$(".form-type-date-popup input.hasDatepicker").attr("placeholder", "DD/MM/YYYY");
			}
			if ($('.hasTimepicker').length) {
				$('.hasTimepicker').attr("placeholder", "HH:MM");
			}
		}

		function dashboardMenuTrail() {
			if ($('.view.view-dashboard').length) {
				$('li.menu-519, li.menu-519 a').addClass('active-trail active')
			}
		}

		function showFilterIfSelected() {
			if ( $('.view-filters .form-type-bef-checkbox').hasClass('highlight') ) {
				$('.view-dashboard .view-filters').addClass('visible');
			}
		}

		function showChangeBox() {
			$('.show-change-box').unbind('click').bind('click', function(e) {
				e.preventDefault();
				$('.change-request-form-container').addClass('show');
			});
			$('.close-change-box').unbind('click').bind('click', function(e) {
				e.preventDefault();
				$('.change-request-form-container').removeClass('show');
			});

			$('#js--request-change').unbind('click').bind('click', function(e) {
				e.preventDefault();
				request_change($(this).data());
			});
		}

		function closeUploadBoxError() {
			$('.form-type-managed-file').on('click touchstart', function() {
				$('.file-upload-js-error').hide();
			});
		}

		function saveClickMobile() {
			$('#aside-container-bookings .btn.hide-desktop').unbind('click').bind('click', function(e) {
				$('#edit-submit--2').trigger('click');
				// document.getElementById("edit-submit--2").disabled = true;
			});
		}

		function disableSubmitButton() {
			// $('#edit-submit--2').unbind('click').bind('click', function(e) {
			// 	document.getElementById("edit-submit--2").disabled = true;
			// });
			Drupal.behaviors.hideSubmitButton = {
			  attach: function(context) {
			    $('form.node-anchor_booking-form', context).once('hideSubmitButton', function () {
			      var $form = $(this);
			      $form.find('input.form-submit').click(function (e) {
			        var el = $(this);
			        el.after('<input type="hidden" name="' + el.attr('name') + '" value="' + el.attr('value') + '" />');
			        return true;
			      });
			      $form.submit(function (e) {
			        if (!e.isPropagationStopped()) {
			          $('input.form-submitssssss', $(this)).attr('disabled', 'disabled');
			          return true;
			        }
			      });
			    });
			  }
			};
		}

		function messageModal() {
			if ($('#messageModal').length) {
				if (!$("body").hasClass("message-modal-open")) {
					$("body").addClass("message-modal-open");
				} else {
					$("body").removeClass("message-modal-open");
				}
			}

			$(".modal-fade-screen, .modal-close").on("click", function() {
				$("body").removeClass("message-modal-open");
				$("body").removeClass("modal-open");
			});

			$(".modal-inner").on("click", function(e) {
				e.stopPropagation();
			});
		}

		function showHideFormOptions() {

			if( typeof is_anchor_user !== 'undefined' && is_anchor_user == '1' ) {
				if ($('#edit-field-customer-who-receives-book-und').length) {
					if( document.getElementById('edit-field-customer-und').value === '' || document.getElementById('edit-field-customer-und').value === '_none' ) {
						$('#edit-field-customer-who-receives-book-und').hide();
					} else {
						$('#edit-field-customer-who-receives-book-und').show();
					}
				}
			}


			if ($('#edit-field-container-size-und').length) {
				$('#edit-refer-container').hide();

				var value = $('#edit-field-container-size-und').val();

				if(value.indexOf('RF') > 0) {
					$('#edit-refer-container').show();
				} else {
					$('#edit-refer-container').hide();
				}

				$('#edit-field-container-size-und').change(function(){

					var value = $(this).val();

					if(value.indexOf('RF') > 0) {
						$('#edit-refer-container').show();
					} else {
						$('#edit-refer-container').hide();
					}
				});
			}

			$('#edit-field-hazardous-material-details').hide();

			if($('#edit-field-contains-hazardous-materia-und').is(':checked')) {
				$('#edit-field-hazardous-material-details').show();
			} else {
				$('#edit-field-hazardous-material-details').hide();
			}

			$('#edit-field-contains-hazardous-materia-und').click(function() {
				if($('#edit-field-contains-hazardous-materia-und').is(':checked')) {
					$('#edit-field-hazardous-material-details').show();
				} else {
					$('#edit-field-hazardous-material-details').hide();
				}
			});


		}

		function dragDrop() {

			window.addEventListener("dragover",function(e){
				e = e || event;
				if (e.target.tagName != "INPUT") { // check wich element is our target
					e.preventDefault();
				}
			},false);

			window.addEventListener("drop",function(e){
				e = e || event;
				if (e.target.tagName != "INPUT") {  // check wich element is our target
					e.preventDefault();
				}
			},false);

			$("input[type='file']").on('dragenter', function(e) {
				e.stopPropagation();
				// $(this).closest('.form-type-managed-file').addClass("hover");
				$(this).parent().parent().addClass("hover");
			});

			$("input[type='file']").on('dragleave', function(e) {
				e.stopPropagation();
				// $(this).closest('.form-type-managed-file').removeClass("hover");
				$(this).parent().parent().removeClass("hover");
			});
		}

		$('input.custom-autocomplete').unbind('keyup').bind('keyup', function(e) {
			var searchField = this;
			// console.log(searchField);
			requiredFieldValidation();

			if (e.which == 40 || e.which == 38) return key_scroll();

			if (!isLoading) {

				var p = $(searchField).val();

				// KEY_CODE 27 == ESC
				if (e.which == 27) {
					$('.autocomplete-list').parent().hide();
					$(searchField).val('');

				} else if (p.length >= 0) {
					isLoading = true;

					setTimeout(function() {
						isLoading = false;
						isDone = false;
						isLoading = false;
						one_stop_filter('autocomplete', searchField);

					}, delay);
				} else if (p.length < 1) {
					isLoading = false;
				}
			}
		});

		// function stickyHeader() {

		// 	// It has to be just above iPad so the iPad doesn't get the aside header height
		// 	var stickyViewport = 1025;
		// 	var window_width = jQuery(window).width();

		// 	if (window_width < stickyViewport) {
		// 		jQuery(".sidebar .shadow-box").trigger("sticky_kit:detach");
		// 	} else {
		// 		make_sticky();
		// 	}

		// 	jQuery(window).resize(function() {
		// 		window_width = jQuery( window ).width();
		// 		jQuery('.sidebar').height('auto');

		// 		if (window_width < stickyViewport) {
		// 			jQuery(".sidebar .shadow-box").trigger("sticky_kit:detach");
		// 		} else {
		// 			make_sticky();
		// 	 	}
		// 	});

		// 	function make_sticky() {
		// 		jQuery('.sidebar').each(function(){
		// 			var $sidebar = jQuery(this);
		// 			var $section = $sidebar.closest('section')
		// 			var contentHeight = $section.height();
		// 			$sidebar.height(contentHeight)
		// 		})
		// 		jQuery('.sidebar .shadow-box').stick_in_parent();
		// 	}

		// 	// var screenSize = $(window).width();
		// 	// var mobileScreen = 480;

		// 	// if (screenSize <= mobileScreen) {
		// 	// 	//$(".shadow-box").trigger("sticky_kit:detach");

		// 	// } else {
		// 	// 	var contentHeight = jQuery('section').height();
		// 	// 	var sidebarHeight = jQuery('.sidebar').height();

		// 	// 	if (contentHeight > sidebarHeight) {
		// 	// 		jQuery('.sidebar').height(contentHeight);
		// 	// 		jQuery('.sidebar .shadow-box').stick_in_parent();
		// 	// 	}
		// 	// }
		// }

		function bookingMobileMenu() {
			$('h2.booking-details').unbind('click').on('click', function(e) {
				if (!$("aside.sidebar").hasClass("open")) {
					e.preventDefault();
					$("aside.sidebar").addClass("open");
				} else {
					$("aside.sidebar").removeClass("open");
				}
			});
		}

		$('input.custom-autocomplete').unbind('focus').on('focus', function(e) {

			// RESET STEP
			stepCount = this.dataset.tabindex;

			if ($('#edit-field-port-of-load-pol-und-0-value').val() != 'AUADL') {
				// RESET INLINE GROUP FIELDS VALUE
				var field_group = get_autocomplete_group();
				var $fc = 1;
				field_group.forEach(function(e, i){
					if( $fc >= stepCount ) {
						e.value = '';
						$(e).trigger('change');
					}
					if( i >= stepCount ) {
						disable_field(e, true);
					}else{
						disable_field(e, false);
					}
					$fc++;
				});
			}

			// RESET FILTERS
			filters = filters.slice(0, (stepCount-1) );

			// RESET DATE FIELDS
			$('#edit-field-1-stop-actual-etd-und-0-value').val('');
			$('#edit-field-etd-und-0-value').val('');
			$('#edit-field-receival-start-date-time-und-0-value').val('');
			$('#edit-field-receival-cut-off-date-time-und-0-value').val('');

			// RESET SHIP NAME FIELD
			if( stepCount == 1 ) {
				$('#edit-field-shipping-line-und-0-value').val('');
			}

			$(this).trigger('keyup');
		});

		$('input.custom-autocomplete').unbind('blur').on('blur', function(e) {
			setTimeout( function(){
				$('.autocomplete-list').parent().hide();
			}, delay);
		})


		$('.customer-select').find('select').change(function(e) {
			one_stop_filter('customer_change', this);
		});

		$('.navigation-menu-button').on('click', function(){
			$(this).toggleClass('is-active');
			$('body').toggleClass('fixed');
		});

	});

	function remove(array, element) {
		const index = array.indexOf(element);
		array.splice(index, 1);
		return array;
	}


	var get_autocomplete_group = function() {
		var group = document.querySelectorAll('.custom-autocomplete');
			lastStep = group.length;
			return group;
	}

	var set_next_step = function(current_step) {
		stepCount = parseInt(current_step) + 1;
		if( stepCount > lastStep ) {
			stepCount = lastStep;
		}

		var nodeGroup = get_autocomplete_group();
		disable_field(nodeGroup[current_step], false);
		$(nodeGroup[current_step]).focus();

	}

	var one_stop_filter = function(method, el) {

		if (method == 'autocomplete') {
			var value = el.value;
			add_filter(el.dataset.filter, value);

			var obj = {};
			obj.value = (value !== '') ? value : 'get_all';
			obj.filters = JSON.stringify(filters);
			obj.filter = el.dataset.filter;
			obj.method = method;
		}

		if (method == 'onload') {
			var value = el.value;

			if (value === '' || value === null) {
				return;
			}
			
			add_filter(el.dataset.filter, value);

			var obj = {};
			obj.value = (value !== '') ? value : 'get_all';
			obj.filters = JSON.stringify(filters);
			obj.filter = el.dataset.filter;
			obj.method = method;
		}

		if (method == 'customer_change') {
			var value = el.value;

			var obj = {};
			obj.value = value;
			obj.method = method;
		}

		if (method == 'field_shipping_line') {
			var value = el.value;

			var obj = {};
			obj.value = value;
			obj.method = 'selectshippingline';
		}

		$().customAjax({
			TYPE: "POST",
			AJAX_URL: Drupal.settings.basePath + "1stop/api",
			POST_STRING: obj,

			onLoad: function() {},

			beforeSend: function() {},

			success: function(data) {

				if (data.success) {
					if (typeof data.onload !== 'undefined') {
						show_final_dates('field_1_stop_actual_etd,field_etd,field_receival_start_date_time,field_receival_cut_off_date_time,', el, data);
					}

					// AUTO COMPLETE
					if (typeof data.autocomplete !== 'undefined') {
						populate_auto_complete_list(data, el);
					}

					// Customer change
					if (typeof data.customer_change !== 'undefined') {
						$('#edit-field-customer-who-receives-book').find('.form-checkboxes').html(data.customer_change);
						$('#edit-field-customer-who-receives-book-und').show();
					}

					// Select shipping line
					if ( typeof data.selectshippingline !== 'undefined' && data.selectshippingline.length ) {
						$('#edit-field-shipping-line-und-0-value').val(data.selectshippingline[0]['description']);
					}
				}

				if (data.error) {
					alert(data.error);
				}
			},

			onEmpty: function() {},

			error: function(data) {}

		});
	}


	/**
	 * THE FINAL RESULTS MA COME BACK AS MULTIPLE RESULTS
	 * LOOP THROUGH THE FINAL ARRAY WHERE "Return terminal" FIELD VALUE
	 * Above changed from "Return terminal" to "Port of load"
	 * EQUALS THE FINAL RESULTS terminal_id PROPERTY // changed to un_loc_code
	 *
	 * @param  {[fields]} 	ALL FILED ID'S USED IN THE AUTOCOMPLETE
	 * @param  {[el]} 		THE LAST ELEMENT FILLED IN
	 * @param  {[data]}		THE FILTERED RESULTS
	 * @return {[void]}
	 */
	var show_final_dates = function(fields, el, data) {
		var elValue = el.value.trim().toUpperCase();
		var index 	= 0;

		data.success.forEach(function(r,i){
			var un_loc_code = r.un_loc_code.trim().toUpperCase();
			if( r.un_loc_code == elValue ) {
				index = i;
			}
		});

		if( typeof data.success[index] !== 'undefined' ) {

			var fields = el.dataset.autoPopulate.split(',');

			for(var f = 0; f < fields.length; f++ ) {
				var field_id = 'edit-' + fields[f].replace(/_/g, "-") + '-und-0-value';
				var field = document.getElementById(field_id);

				if( fields[f] == 'field_1_stop_actual_etd' ) {
					field.value = data.success[index].actual_depart_date;
				}

				if( fields[f] == 'field_etd' ) {
					field.value = data.success[index].etd;
				}

				if( fields[f] == 'field_receival_start_date_time' ) {
					field.value = data.success[index].export_receival_commencement_date;
				}

				if( fields[f] == 'field_receival_cut_off_date_time' ) {
					field.value = data.success[index].cargo_cutoff_date;
				}

				if (data.success[index].actual_depart_date !== '' && data.success[index].actual_depart_date !== 'N/A') {
					$('.oneStopATD').show();
					$('.oneStopETD').hide();
				}
				// Focus on T/S port after final auto input
				$('input#edit-field-transhipment-port-t-s-und').focus();
			}
		}
	}

	var populate_auto_complete_list = function(data, el) {

		var elwidth = $(el).innerWidth();
		var elheight = $(el).innerHeight();
		var elposition = $(el).position();
		var eltop = elposition.top + elheight;

		var html = '<div id="autocomplete" style="width: ' + elwidth + 'px; top: ' + eltop + 'px;"><ul class="autocomplete-list">';

		data.success.forEach(function(list, i) {
			var filter = data.filter
			html += '<li tabindex="' + i + '" ><a class="PopulatedList" href="#" >' + list[filter] + '</a></li>';
		});

		html += '</ul></div>';

		$('#autocomplete').remove();

		$(el).after(html);

		$('.PopulatedList').unbind('click').bind('click', function(e) {
			e.preventDefault();
			$('#autocomplete ul').html('');
			$('#autocomplete ul').parent().hide();
			$('#autocomplete').prev().val($(this).text()).change();
			//
			add_filter(data.filter, $(this).text());

			if(typeof el.dataset.autoPopulate !== 'undefined') {
				if( el.dataset.autoPopulate == 'field_1_stop_actual_etd,field_etd,field_receival_start_date_time,field_receival_cut_off_date_time,') {
					show_final_dates(el.dataset.autoPopulate, el, data);
					return;
				}
				setTimeout(function() {
					one_stop_filter(el.dataset.autoPopulate, el);
				}, 10 );
			}

			stepCount = el.dataset.tabindex;
			set_next_step(stepCount);
		});

		/*$('#edit-field-shipping-line-code-booking-und-0-value').change(function(e) {
			var shippingvalue = this;
			setTimeout(function() {
				one_stop_filter('selectshippingline', shippingvalue);
			}, delay );
		});*/
	}

	var key_scroll = function() {
		var populate_list = $('.autocomplete-list');

		$(populate_list).on('focus', 'li', function() {
			$(this).addClass('hover-state').siblings().removeClass();
			$(this).closest(populate_list).scrollTop($(this).index() * $(this).outerHeight());

		}).on('keydown', 'li', function(e) {
			if (e.keyCode == 40) {
				$(this).next().focus();
				return false;

			} else if (e.keyCode == 38) {
				$(this).prev().focus();
				return false;
			}

			if (e.keyCode == 13) {
				$(this).children().click();
			}
		}).find('li').first().focus();
	}

	function init_filters() {
		var fields 			= ['shipping-line-code-booking', 'vessel-name', 'vessel-voyage', 'lloyds-number', 'return-terminal', 'port-of-load-pol'];
		var filter_names 	= ['operators', 'ship_name', 'ship_operator_voyage_out', 'lloyds_id', 'terminal_id', 'un_loc_code'];

		fields.forEach(function(f, i) {
			var field_id = 'edit-field-' + f + '-und-0-value';
			var field_val = $('#' + field_id).val();
			if( field_val !== '' ) {
				add_filter(filter_names[i], field_val);
			}
		});
	}

	function add_filter(name, value) {

	    if( filters.length > 0 ) {

	        var exists = false;

	        filters.forEach( function(f,i){
	            if( f.filter == name ) {
	                f.value = value;
	                exists = true;
	            }
	        });

	        // {DOSN'T EXIST} ADD TO THE FILTER
	        if( !exists ) {
	            filters.push({ filter: name, value: value });
	        }
	        else{
	            // {DOES EXIST} UPDATE THE FILTER
	            filters.forEach( function(f,i) {
	                if( f.filter == name ) {
	                    f.value = value;
	                }
	            });
	        }
	    }
	    else{
	        filters.push({ filter: name, value: value });
	    }
	}

	function hamburger() {
		$(window).resize(function() {
			var more = document.getElementById("js-navigation-more");
			if ($(more).length > 0) {
				var windowWidth = $(window).width();
				var moreLeftSideToPageLeftSide = $(more).offset().left;
				var moreLeftSideToPageRightSide = windowWidth - moreLeftSideToPageLeftSide;

				if (moreLeftSideToPageRightSide < 330) {
					$("#js-navigation-more .submenu .submenu").removeClass("fly-out-right");
					$("#js-navigation-more .submenu .submenu").addClass("fly-out-left");
				}

				if (moreLeftSideToPageRightSide > 330) {
					$("#js-navigation-more .submenu .submenu").removeClass("fly-out-left");
					$("#js-navigation-more .submenu .submenu").addClass("fly-out-right");
				}
			}
		});

		var menuToggle = $("#js-mobile-menu").unbind();

		menuToggle.on("click", function(e) {
			e.preventDefault();
			// Scroll out modal overlay
			$(".mobile-navigation-menu").toggleClass('show');

			// Stop overscroll when overlay is active
			$('body').toggleClass('overflow-hidden')
		});
	}

	function modalOpen() {

		// Triggers UN Codes

		$(".js--add-new-uncode").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, unCodes.addUnCodesHTML($(this).data()), unCodes.addUnCodes, {
					action: $(this).data('action'),
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		$(".js--edit-uncode").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, unCodes.editUnCodesHTML($(this).data()), unCodes.editUnCodes, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
					autofire : true,
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		$(".js--delete-uncode").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, unCodes.deleteUnCodesHTML($(this).data()), unCodes.deleteUnCodes, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		//  Triggers HS Codes

		$(".js--add-new-hscode").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, hsCodes.addHsCodesHTML($(this).data()), hsCodes.addHsCodes, {
					action: $(this).data('action'),
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		$(".js--edit-hscode").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, hsCodes.editHsCodesHTML($(this).data()), hsCodes.editHsCodes, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
					autofire : true,
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		$(".js--delete-hscode").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, hsCodes.deleteHsCodesHTML($(this).data()), hsCodes.deleteHsCodes, {
					action: $(this).data('action'),
					tid: $(this).data('tid')
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		// triggers Shipping line

		$(".js--add-new-shippingline").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, shippingLine.addShippingLineHTML($(this).data()), shippingLine.addShippingLine, {
					action: $(this).data('action'),
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		$(".js--edit-shippingline").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, shippingLine.editShippingLineHTML($(this).data()), shippingLine.editShippingLine, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
					autofire : true,
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		$(".js--delete-shippingline").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, shippingLine.deleteShippingLineHTML($(this).data()), shippingLine.deleteShippingLine, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		$(".js--event-history").on("click", function(e) {
			if ( $('#messageModal').length ) {
				document.getElementById('messageModal').parentNode.parentNode.removeChild(document.getElementById('messageModal').parentNode)
			}
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		// Triggers Release Depots

		$(".js--add-new-releasedepots").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, releaseDepots.addReleaseDepotsHTML($(this).data()), releaseDepots.addReleaseDepots, {
					action: $(this).data('action'),
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		$(".js--edit-releasedepots").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, releaseDepots.editReleaseDepotsHTML($(this).data()), releaseDepots.editReleaseDepots, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
					autofire : true,
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		$(".js--delete-releasedepots").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, releaseDepots.deleteReleaseDepotsHTML($(this).data()), releaseDepots.deleteReleaseDepots, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		// Triggers Release Depots

		$(".js--add-new-terminals").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, terminals.addTerminalsHTML($(this).data()), terminals.addTerminals, {
					action: $(this).data('action'),
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		$(".js--edit-terminals").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, terminals.editTerminalsHTML($(this).data()), terminals.editTerminals, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
					autofire : true,
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

		$(".js--delete-terminal").on("click", function(e) {
			if (!$("body").hasClass("modal-open")) {
				e.preventDefault();
				modal(this, terminals.deleteTerminalsHTML($(this).data()), terminals.deleteTerminals, {
					action: $(this).data('action'),
					tid: $(this).data('tid'),
				});
				$("body").addClass("modal-open data-code-modal");
			} else {
				$("body").removeClass("modal-open data-code-modal");
			}
		});

	}

	function expander() {
		$('.expander-trigger').click(function(){
			$(this).parent().toggleClass('expander-hidden');
		});

		// Search expander
		$('.search-button').click(function(){
			// Remove the booking dropdown
			$('.booking-content').addClass('expander-hidden');
			$('.active-page').removeClass('rotate');

			$('.search-content').toggleClass('expander-hidden');

			// Change the search button to an X when there is input text
			$('.search-icon').toggleClass('active');
			$('.close-icon').toggleClass('active');
		});

		// Booking expander
		$('.page-trigger').click(function() {
			// Remove the search dropdown
			$('.search-content').addClass('expander-hidden');

			// Rotate the Booking arrow
			$('.active-page').toggleClass('rotate');
			$('.booking-content').toggleClass('expander-hidden');
		});
		// Date codes dropdown
		$('.active-page').click(function() {
		$(this).parent().find('#data-codes-menu').toggleClass('show');
		$(this).find('.arrow-logo').toggleClass('rotate');

		// 	// Rotate the Booking arrow
			// $('.active-page-content span').toggleClass('rotate');
		});
	}

	function dropMenu() {
		var userNavActive = false
		$(".user-nav-profile").click(function(e) {
			var self = this
			userNavActive = !userNavActive
			e.stopPropagation()
			updateUserNav(self)

			$('.user-nav-dropdown').one('click', function(e){e.stopPropagation()})
			$(window).one('click', function(){
				if (userNavActive) {
					userNavActive = false
					updateUserNav(self)
				}
			})
		});

		function updateUserNav(el){
			$(el).toggleClass("active", userNavActive);
			var navMenu = $(el).parent().find('.user-nav-dropdown');
			navMenu.toggleClass('show-menu', userNavActive);
		}

		$('.filters-button.date').click(function() {
			$('.view .view-filters').toggleClass('visible-date');
			if ($('.view .view-filters').hasClass("visible-customer")) {
				$('.view .view-filters').toggleClass('visible-customer');
			}
		});

		$('.filters-button.customer').click(function() {
			$('.view .view-filters').toggleClass('visible-customer');
			if ($('.view .view-filters').hasClass("visible-date")) {
				$('.view .view-filters').toggleClass('visible-date');
			}
		});

		$(".active-page-container > span").click(function() {
			$('.dashboard-nav').toggleClass('visible');
			$(this).parent().toggleClass('rotate');
		});

		$(".booking-nav-title").click(function() {
			$(this).toggleClass('visible');
		});

		$(".show-booking-information").click(function() {
			$(this).toggleClass('visible');
			$('.sidebar-group').toggleClass('visible');
		});

	}

	// Add the clear X button for search input on Data Codes page
	function searchTextInput() {
		$('#edit-combine').keypress(function() {
			var dataCodeSearch = $('#edit-combine').length;

			if (dataCodeSearch > 0) {
				$('.views-reset-button').addClass('visible')
			} else {
				$('.views-reset-button').removeClass('visible')
			}
		});
	}


	/**
	* Anchor Modal Popup
	**/

	modal = function(elem, html, callback, args) {

		var modal = $("#anchorModal");
			modal.find('.modal-content').html(html.output);

		if (args.autofire !== undefined) {
			if (typeof callback === 'function') {
				callback(modal.dataset, args);
			}
			return;
		}

		$('#modal-btn-cancel').click( function(e) {
			e.preventDefault();
			$('#anchorModal').find('.modal-close').click();
		});

		$(modal).find('#'+html.btn_id).click(function(e) {
			e.preventDefault();
			if (typeof callback === 'function') {
				callback(modal.dataset, args);
			}
		});
	}

	var disable_button = function(el, disable) {
		if( disable ) {
			el.setAttribute('disabled', true);
			el.classList.add('disabled');
		}
		else{
			el.removeAttribute('disabled', false);
			el.classList.remove('disabled');
		}
	}

	unCodes = {
		addUnCodesHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Add new port</h2>';
				html += '<p id="modal-error"></p>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="port-code" class="form-text" placeholder="Port code *">';
				html += '<label for="port-code">Port code <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="port-name" class="form-text" placeholder="Port name *">';
				html += '<label for="port-name">Port name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="select-wrapper form-item">';
				html += '<label for="port-country">Port country <span class="form-required" title="This field is required.">*</span></label>';
				html += '<select id="port-country" name="field_port_country" class="form-select"><option value="none">- None -</option><option value="AF">Afghanistan</option><option value="AX">Aland Islands</option><option value="AL">Albania</option><option value="DZ">Algeria</option><option value="AS">American Samoa</option><option value="AD">Andorra</option><option value="AO">Angola</option><option value="AI">Anguilla</option><option value="AQ">Antarctica</option><option value="AG">Antigua and Barbuda</option><option value="AR">Argentina</option><option value="AM">Armenia</option><option value="AW">Aruba</option><option value="AU">Australia</option><option value="AT">Austria</option><option value="AZ">Azerbaijan</option><option value="BS">Bahamas</option><option value="BH">Bahrain</option><option value="BD">Bangladesh</option><option value="BB">Barbados</option><option value="BY">Belarus</option><option value="BE">Belgium</option><option value="BZ">Belize</option><option value="BJ">Benin</option><option value="BM">Bermuda</option><option value="BT">Bhutan</option><option value="BO">Bolivia</option><option value="BA">Bosnia and Herzegovina</option><option value="BW">Botswana</option><option value="BV">Bouvet Island</option><option value="BR">Brazil</option><option value="IO">British Indian Ocean Territory</option><option value="VG">British Virgin Islands</option><option value="BN">Brunei</option><option value="BG">Bulgaria</option><option value="BF">Burkina Faso</option><option value="BI">Burundi</option><option value="KH">Cambodia</option><option value="CM">Cameroon</option><option value="CA">Canada</option><option value="CV">Cape Verde</option><option value="BQ">Caribbean Netherlands</option><option value="KY">Cayman Islands</option><option value="CF">Central African Republic</option><option value="TD">Chad</option><option value="CL">Chile</option><option value="CN">China</option><option value="CX">Christmas Island</option><option value="CC">Cocos (Keeling) Islands</option><option value="CO">Colombia</option><option value="KM">Comoros</option><option value="CG">Congo (Brazzaville)</option><option value="CD">Congo (Kinshasa)</option><option value="CK">Cook Islands</option><option value="CR">Costa Rica</option><option value="HR">Croatia</option><option value="CU">Cuba</option><option value="CW">Curaçao</option><option value="CY">Cyprus</option><option value="CZ">Czech Republic</option><option value="DK">Denmark</option><option value="DJ">Djibouti</option><option value="DM">Dominica</option><option value="DO">Dominican Republic</option><option value="EC">Ecuador</option><option value="EG">Egypt</option><option value="SV">El Salvador</option><option value="GQ">Equatorial Guinea</option><option value="ER">Eritrea</option><option value="EE">Estonia</option><option value="ET">Ethiopia</option><option value="FK">Falkland Islands</option><option value="FO">Faroe Islands</option><option value="FJ">Fiji</option><option value="FI">Finland</option><option value="FR">France</option><option value="GF">French Guiana</option><option value="PF">French Polynesia</option><option value="TF">French Southern Territories</option><option value="GA">Gabon</option><option value="GM">Gambia</option><option value="GE">Georgia</option><option value="DE">Germany</option><option value="GH">Ghana</option><option value="GI">Gibraltar</option><option value="GR">Greece</option><option value="GL">Greenland</option><option value="GD">Grenada</option><option value="GP">Guadeloupe</option><option value="GU">Guam</option><option value="GT">Guatemala</option><option value="GG">Guernsey</option><option value="GN">Guinea</option><option value="GW">Guinea-Bissau</option><option value="GY">Guyana</option><option value="HT">Haiti</option><option value="HM">Heard Island and McDonald Islands</option><option value="HN">Honduras</option><option value="HK">Hong Kong S.A.R., China</option><option value="HU">Hungary</option><option value="IS">Iceland</option><option value="IN">India</option><option value="ID">Indonesia</option><option value="IR">Iran</option><option value="IQ">Iraq</option><option value="IE">Ireland</option><option value="IM">Isle of Man</option><option value="IL">Israel</option><option value="IT">Italy</option><option value="CI">Ivory Coast</option><option value="JM">Jamaica</option><option value="JP">Japan</option><option value="JE">Jersey</option><option value="JO">Jordan</option><option value="KZ">Kazakhstan</option><option value="KE">Kenya</option><option value="KI">Kiribati</option><option value="KW">Kuwait</option><option value="KG">Kyrgyzstan</option><option value="LA">Laos</option><option value="LV">Latvia</option><option value="LB">Lebanon</option><option value="LS">Lesotho</option><option value="LR">Liberia</option><option value="LY">Libya</option><option value="LI">Liechtenstein</option><option value="LT">Lithuania</option><option value="LU">Luxembourg</option><option value="MO">Macao S.A.R., China</option><option value="MK">Macedonia</option><option value="MG">Madagascar</option><option value="MW">Malawi</option><option value="MY">Malaysia</option><option value="MV">Maldives</option><option value="ML">Mali</option><option value="MT">Malta</option><option value="MH">Marshall Islands</option><option value="MQ">Martinique</option><option value="MR">Mauritania</option><option value="MU">Mauritius</option><option value="YT">Mayotte</option><option value="MX">Mexico</option><option value="FM">Micronesia</option><option value="MD">Moldova</option><option value="MC">Monaco</option><option value="MN">Mongolia</option><option value="ME">Montenegro</option><option value="MS">Montserrat</option><option value="MA">Morocco</option><option value="MZ">Mozambique</option><option value="MM">Myanmar</option><option value="NA">Namibia</option><option value="NR">Nauru</option><option value="NP">Nepal</option><option value="NL">Netherlands</option><option value="AN">Netherlands Antilles</option><option value="NC">New Caledonia</option><option value="NZ">New Zealand</option><option value="NI">Nicaragua</option><option value="NE">Niger</option><option value="NG">Nigeria</option><option value="NU">Niue</option><option value="NF">Norfolk Island</option><option value="MP">Northern Mariana Islands</option><option value="KP">North Korea</option><option value="NO">Norway</option><option value="OM">Oman</option><option value="PK">Pakistan</option><option value="PW">Palau</option><option value="PS">Palestinian Territory</option><option value="PA">Panama</option><option value="PG">Papua New Guinea</option><option value="PY">Paraguay</option><option value="PE">Peru</option><option value="PH">Philippines</option><option value="PN">Pitcairn</option><option value="PL">Poland</option><option value="PT">Portugal</option><option value="PR">Puerto Rico</option><option value="QA">Qatar</option><option value="RE">Reunion</option><option value="RO">Romania</option><option value="RU">Russia</option><option value="RW">Rwanda</option><option value="BL">Saint Barthélemy</option><option value="SH">Saint Helena</option><option value="KN">Saint Kitts and Nevis</option><option value="LC">Saint Lucia</option><option value="MF">Saint Martin (French part)</option><option value="PM">Saint Pierre and Miquelon</option><option value="VC">Saint Vincent and the Grenadines</option><option value="WS">Samoa</option><option value="SM">San Marino</option><option value="ST">Sao Tome and Principe</option><option value="SA">Saudi Arabia</option><option value="SN">Senegal</option><option value="RS">Serbia</option><option value="SC">Seychelles</option><option value="SL">Sierra Leone</option><option value="SG">Singapore</option><option value="SX">Sint Maarten</option><option value="SK">Slovakia</option><option value="SI">Slovenia</option><option value="SB">Solomon Islands</option><option value="SO">Somalia</option><option value="ZA">South Africa</option><option value="GS">South Georgia and the South Sandwich Islands</option><option value="KR">South Korea</option><option value="SS">South Sudan</option><option value="ES">Spain</option><option value="LK">Sri Lanka</option><option value="SD">Sudan</option><option value="SR">Suriname</option><option value="SJ">Svalbard and Jan Mayen</option><option value="SZ">Swaziland</option><option value="SE">Sweden</option><option value="CH">Switzerland</option><option value="SY">Syria</option><option value="TW">Taiwan</option><option value="TJ">Tajikistan</option><option value="TZ">Tanzania</option><option value="TH">Thailand</option><option value="TL">Timor-Leste</option><option value="TG">Togo</option><option value="TK">Tokelau</option><option value="TO">Tonga</option><option value="TT">Trinidad and Tobago</option><option value="TN">Tunisia</option><option value="TR">Turkey</option><option value="TM">Turkmenistan</option><option value="TC">Turks and Caicos Islands</option><option value="TV">Tuvalu</option><option value="VI">U.S. Virgin Islands</option><option value="UG">Uganda</option><option value="UA">Ukraine</option><option value="AE">United Arab Emirates</option><option value="GB">United Kingdom</option><option value="US">United States</option><option value="UM">United States Minor Outlying Islands</option><option value="UY">Uruguay</option><option value="UZ">Uzbekistan</option><option value="VU">Vanuatu</option><option value="VA">Vatican</option><option value="VE">Venezuela</option><option value="VN">Vietnam</option><option value="WF">Wallis and Futuna</option><option value="EH">Western Sahara</option><option value="YE">Yemen</option><option value="ZM">Zambia</option><option value="ZW">Zimbabwe</option></select>';
				html += '</div>';

				html += '<button id="modal-btn-cta" class="btn">Add</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		editUnCodesHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Update</h2>';
				html += '<p id="modal-error"></p>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="port-code" class="form-text" placeholder="Port code *">';
				html += '<label for="port-code">Port code <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="port-name" class="form-text" placeholder="Port name *">';
				html += '<label for="port-name">Port name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="select-wrapper form-item">';
				html += '<label for="port-country">Port country</label>';
				html += '<select id="port-country" name="field_port_country" class="form-select"><option value="none">- None -</option><option value="AF">Afghanistan</option><option value="AX">Aland Islands</option><option value="AL">Albania</option><option value="DZ">Algeria</option><option value="AS">American Samoa</option><option value="AD">Andorra</option><option value="AO">Angola</option><option value="AI">Anguilla</option><option value="AQ">Antarctica</option><option value="AG">Antigua and Barbuda</option><option value="AR">Argentina</option><option value="AM">Armenia</option><option value="AW">Aruba</option><option value="AU">Australia</option><option value="AT">Austria</option><option value="AZ">Azerbaijan</option><option value="BS">Bahamas</option><option value="BH">Bahrain</option><option value="BD">Bangladesh</option><option value="BB">Barbados</option><option value="BY">Belarus</option><option value="BE">Belgium</option><option value="BZ">Belize</option><option value="BJ">Benin</option><option value="BM">Bermuda</option><option value="BT">Bhutan</option><option value="BO">Bolivia</option><option value="BA">Bosnia and Herzegovina</option><option value="BW">Botswana</option><option value="BV">Bouvet Island</option><option value="BR">Brazil</option><option value="IO">British Indian Ocean Territory</option><option value="VG">British Virgin Islands</option><option value="BN">Brunei</option><option value="BG">Bulgaria</option><option value="BF">Burkina Faso</option><option value="BI">Burundi</option><option value="KH">Cambodia</option><option value="CM">Cameroon</option><option value="CA">Canada</option><option value="CV">Cape Verde</option><option value="BQ">Caribbean Netherlands</option><option value="KY">Cayman Islands</option><option value="CF">Central African Republic</option><option value="TD">Chad</option><option value="CL">Chile</option><option value="CN">China</option><option value="CX">Christmas Island</option><option value="CC">Cocos (Keeling) Islands</option><option value="CO">Colombia</option><option value="KM">Comoros</option><option value="CG">Congo (Brazzaville)</option><option value="CD">Congo (Kinshasa)</option><option value="CK">Cook Islands</option><option value="CR">Costa Rica</option><option value="HR">Croatia</option><option value="CU">Cuba</option><option value="CW">Curaçao</option><option value="CY">Cyprus</option><option value="CZ">Czech Republic</option><option value="DK">Denmark</option><option value="DJ">Djibouti</option><option value="DM">Dominica</option><option value="DO">Dominican Republic</option><option value="EC">Ecuador</option><option value="EG">Egypt</option><option value="SV">El Salvador</option><option value="GQ">Equatorial Guinea</option><option value="ER">Eritrea</option><option value="EE">Estonia</option><option value="ET">Ethiopia</option><option value="FK">Falkland Islands</option><option value="FO">Faroe Islands</option><option value="FJ">Fiji</option><option value="FI">Finland</option><option value="FR">France</option><option value="GF">French Guiana</option><option value="PF">French Polynesia</option><option value="TF">French Southern Territories</option><option value="GA">Gabon</option><option value="GM">Gambia</option><option value="GE">Georgia</option><option value="DE">Germany</option><option value="GH">Ghana</option><option value="GI">Gibraltar</option><option value="GR">Greece</option><option value="GL">Greenland</option><option value="GD">Grenada</option><option value="GP">Guadeloupe</option><option value="GU">Guam</option><option value="GT">Guatemala</option><option value="GG">Guernsey</option><option value="GN">Guinea</option><option value="GW">Guinea-Bissau</option><option value="GY">Guyana</option><option value="HT">Haiti</option><option value="HM">Heard Island and McDonald Islands</option><option value="HN">Honduras</option><option value="HK">Hong Kong S.A.R., China</option><option value="HU">Hungary</option><option value="IS">Iceland</option><option value="IN">India</option><option value="ID">Indonesia</option><option value="IR">Iran</option><option value="IQ">Iraq</option><option value="IE">Ireland</option><option value="IM">Isle of Man</option><option value="IL">Israel</option><option value="IT">Italy</option><option value="CI">Ivory Coast</option><option value="JM">Jamaica</option><option value="JP">Japan</option><option value="JE">Jersey</option><option value="JO">Jordan</option><option value="KZ">Kazakhstan</option><option value="KE">Kenya</option><option value="KI">Kiribati</option><option value="KW">Kuwait</option><option value="KG">Kyrgyzstan</option><option value="LA">Laos</option><option value="LV">Latvia</option><option value="LB">Lebanon</option><option value="LS">Lesotho</option><option value="LR">Liberia</option><option value="LY">Libya</option><option value="LI">Liechtenstein</option><option value="LT">Lithuania</option><option value="LU">Luxembourg</option><option value="MO">Macao S.A.R., China</option><option value="MK">Macedonia</option><option value="MG">Madagascar</option><option value="MW">Malawi</option><option value="MY">Malaysia</option><option value="MV">Maldives</option><option value="ML">Mali</option><option value="MT">Malta</option><option value="MH">Marshall Islands</option><option value="MQ">Martinique</option><option value="MR">Mauritania</option><option value="MU">Mauritius</option><option value="YT">Mayotte</option><option value="MX">Mexico</option><option value="FM">Micronesia</option><option value="MD">Moldova</option><option value="MC">Monaco</option><option value="MN">Mongolia</option><option value="ME">Montenegro</option><option value="MS">Montserrat</option><option value="MA">Morocco</option><option value="MZ">Mozambique</option><option value="MM">Myanmar</option><option value="NA">Namibia</option><option value="NR">Nauru</option><option value="NP">Nepal</option><option value="NL">Netherlands</option><option value="AN">Netherlands Antilles</option><option value="NC">New Caledonia</option><option value="NZ">New Zealand</option><option value="NI">Nicaragua</option><option value="NE">Niger</option><option value="NG">Nigeria</option><option value="NU">Niue</option><option value="NF">Norfolk Island</option><option value="MP">Northern Mariana Islands</option><option value="KP">North Korea</option><option value="NO">Norway</option><option value="OM">Oman</option><option value="PK">Pakistan</option><option value="PW">Palau</option><option value="PS">Palestinian Territory</option><option value="PA">Panama</option><option value="PG">Papua New Guinea</option><option value="PY">Paraguay</option><option value="PE">Peru</option><option value="PH">Philippines</option><option value="PN">Pitcairn</option><option value="PL">Poland</option><option value="PT">Portugal</option><option value="PR">Puerto Rico</option><option value="QA">Qatar</option><option value="RE">Reunion</option><option value="RO">Romania</option><option value="RU">Russia</option><option value="RW">Rwanda</option><option value="BL">Saint Barthélemy</option><option value="SH">Saint Helena</option><option value="KN">Saint Kitts and Nevis</option><option value="LC">Saint Lucia</option><option value="MF">Saint Martin (French part)</option><option value="PM">Saint Pierre and Miquelon</option><option value="VC">Saint Vincent and the Grenadines</option><option value="WS">Samoa</option><option value="SM">San Marino</option><option value="ST">Sao Tome and Principe</option><option value="SA">Saudi Arabia</option><option value="SN">Senegal</option><option value="RS">Serbia</option><option value="SC">Seychelles</option><option value="SL">Sierra Leone</option><option value="SG">Singapore</option><option value="SX">Sint Maarten</option><option value="SK">Slovakia</option><option value="SI">Slovenia</option><option value="SB">Solomon Islands</option><option value="SO">Somalia</option><option value="ZA">South Africa</option><option value="GS">South Georgia and the South Sandwich Islands</option><option value="KR">South Korea</option><option value="SS">South Sudan</option><option value="ES">Spain</option><option value="LK">Sri Lanka</option><option value="SD">Sudan</option><option value="SR">Suriname</option><option value="SJ">Svalbard and Jan Mayen</option><option value="SZ">Swaziland</option><option value="SE">Sweden</option><option value="CH">Switzerland</option><option value="SY">Syria</option><option value="TW">Taiwan</option><option value="TJ">Tajikistan</option><option value="TZ">Tanzania</option><option value="TH">Thailand</option><option value="TL">Timor-Leste</option><option value="TG">Togo</option><option value="TK">Tokelau</option><option value="TO">Tonga</option><option value="TT">Trinidad and Tobago</option><option value="TN">Tunisia</option><option value="TR">Turkey</option><option value="TM">Turkmenistan</option><option value="TC">Turks and Caicos Islands</option><option value="TV">Tuvalu</option><option value="VI">U.S. Virgin Islands</option><option value="UG">Uganda</option><option value="UA">Ukraine</option><option value="AE">United Arab Emirates</option><option value="GB">United Kingdom</option><option value="US">United States</option><option value="UM">United States Minor Outlying Islands</option><option value="UY">Uruguay</option><option value="UZ">Uzbekistan</option><option value="VU">Vanuatu</option><option value="VA">Vatican</option><option value="VE">Venezuela</option><option value="VN">Vietnam</option><option value="WF">Wallis and Futuna</option><option value="EH">Western Sahara</option><option value="YE">Yemen</option><option value="ZM">Zambia</option><option value="ZW">Zimbabwe</option></select>';
				html += '</div>';

				html += '<button id="modal-btn-cta" class="btn">Update</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		deleteUnCodesHTML: function(args) {
			var name = (typeof args.name !== 'undefined' && args.name !== '' ) ? '<strong>' + args.name + '</strong>' : 'this port';
			var obj = {};
			var html = '';
				html += '<h2>Delete port</h2>';
				html += '<p id="modal-error"></p>';
				html += '<p>Are you sure you want to delete ' + name + '?</p>';
				html += '<button id="modal-btn-cta" class="btn">Delete</button>';
				html += '<button id="modal-btn-cancel" class="btn secondary">Cancel</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		errorHTML: function(error, level) {
			var errorElem = document.getElementById('modal-error');
				if(null == errorElem){ return; }

				errorElem.innerHTML = error;

				if( level !== '')
					errorElem.classList.add(level);
		},

		clearError: function() {
			unCodes.errorHTML('', '');
			$('.modal-content').find('input').each( function(i,v){
				$(v).removeClass('error');
			});
			$('.modal-content').find('select').each( function(i,v){
				$(v).removeClass('error');
			});
			$('#modal-error').addClass('hidden');
		},

		addUnCodes: function(modal_dataset, args) {
			var btnCta 		= document.getElementById('modal-btn-cta');
			var inputData 	= getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'un_codes',
				method		: 'add',
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,

				beforeSend: function() {
					//throbber(btnCta);
					disable_button(btnCta, true);
				},
				success: function(data) {

					if (data.success) {
						unCodes.clearError();
						//unCodes.errorHTML(data.message, data.level);
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');

					disable_button(btnCta, false);
				}
			});
		},

		editUnCodes: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');
			var inputData = getInputFieldVals('.input-wrapper, .select-wrapper');

			var settings = {
				apiclass	: 'un_codes',
				method		: 'edit',
				action		: args.action,
				tid 		: args.tid
			}
			$.extend(settings, inputData);


			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						unCodes.clearError();

						if( args.reload ) {
							location.reload();
						}

						// REGENERATE THE FIELD VALUES
						if( data.term ) {
							$('#port-code').val(data.term.code);
							$('#port-name').val(data.term.name);
							$('#port-country').val(data.term.country).attr("selected", "selected");
						}

						// TRIGGER UPDATE BUTTON
						$('#modal-btn-cta').click(function(e){
							e.preventDefault();

							unCodes.editUnCodes(
								modal_dataset,
								{
									tid 	: args.tid,
									action 	: 'update',
									reload 	: true,
								}
							);
						});

						$('#anchorModal').find('.modal-close').click(function(){
							location.reload();
						});
					}
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					console.log(data)
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		deleteUnCodes: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'un_codes',
				method		: 'delete',
				tid 		: args.tid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},
	}

	hsCodes = {
		addHsCodesHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Add new HS Code</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="hscode-name" class="form-text" placeholder="Enter full HS Code *">';
				html += '<label for="hscode-name">Enter full HS Code <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Add</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		editHsCodesHTML: function() {
			var obj = {};
			var html = '<h2>Edit HS Code</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="hscode-name" class="form-text" placeholder="Enter full HS Code *">';
				html += '<label for="hscode-name">Enter full HS Code <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Update</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		deleteHsCodesHTML: function(args) {

			var name = (typeof args.name !== 'undefined' && args.name !== '' ) ? '<strong>' + args.name + '</strong>' : 'this HS Code';
			var obj = {};
			var html = '<h2>Delete HS Code</h2>';
				html += '<p id="modal-error"></p>';
				html += '<p>Are you sure you want to delete ' + name + '?</p>';
				html += '<button id="modal-btn-cta" class="btn">Delete</button>';
				html += '<button id="modal-btn-cancel" class="btn secondary">Cancel</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		addHsCodes: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'hs_codes',
				method		: 'add',
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,

				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {

					if (data.success) {
						unCodes.clearError();
						//unCodes.errorHTML(data.message, data.level);
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		editHsCodes: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'hs_codes',
				method		: 'edit',
				action		: args.action,
				tid 		: args.tid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						unCodes.clearError();

						if( args.reload ) {
							location.reload();
						}

						// REGENERATE THE FIELD VALUES
						if( data.term ) {
							$('#hscode-name').val(data.term.name);
						}

						// TRIGGER UPDATE BUTTON
						$('#modal-btn-cta').click(function(e){
							e.preventDefault();

							hsCodes.editHsCodes(
								modal_dataset,
								{
									tid 	: args.tid,
									action 	: 'update',
									reload 	: true,
								}
							);
						});

						$('#anchorModal').find('.modal-close').click(function(){
							location.reload();
						});
					}
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		deleteHsCodes: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'hs_codes',
				method		: 'delete',
				tid 		: args.tid
			}

			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},
	}

	shippingLine = {
		addShippingLineHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Add new Shipping Line</h2>';
				html += '<p id="modal-error"></p>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="shipping-line-code" class="form-text" placeholder="Enter Shipping Line Code *">';
				html += '<label for="shipping-line-code">Enter Shipping Line Code <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="shipping-line-name" class="form-text" placeholder="Enter Shipping Line name *">';
				html += '<label for="shipping-line-name">Enter Shipping Line name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="inttra-scac-code" class="form-text" placeholder="Inttra SCAC Code *">';
				html += '<label for="inttra-scac-code">Inttra SCAC Code <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper textarea-wrapper form-item">';
				html += '<textarea id="shipping-line-tc" class="form-text"></textarea>';
				html += '<label for="shipping-line-tc">Terms and conditions (HTML format)</label>';
				html += '</div>';

				html += '<button id="modal-btn-cta" class="btn">Add</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		editShippingLineHTML: function() {
			var obj = {};
			var html = '<h2>Edit Shipping Line</h2>';
				html += '<p id="modal-error"></p>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="shipping-line-code" class="form-text" placeholder="Enter Shipping Line Code *">';
				html += '<label for="shipping-line-code">Enter Shipping Line Code <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="shipping-line-name" class="form-text" placeholder="Enter Shipping Line name *">';
				html += '<label for="shipping-line-name">Enter Shipping Line name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="inttra-scac-code" class="form-text" placeholder="Inttra SCAC Code *">';
				html += '<label for="inttra-scac-code">Enter Inttra SCAC Code <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper textarea-wrapper form-item">';
				html += '<textarea id="shipping-line-tc" class="form-text"></textarea>';
				html += '<label for="shipping-line-tc">Terms and conditions (HTML format)</label>';
				html += '</div>';

				html += '<button id="modal-btn-cta" class="btn">Update</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		deleteShippingLineHTML: function(args) {

			var name = (typeof args.name !== 'undefined' && args.name !== '' ) ? '<strong>' + args.name + '</strong>' : 'this Shipping Line';
			var obj = {};
			var html = '<h2>Delete Shipping Line</h2>';
				html += '<p id="modal-error"></p>';
				html += '<p>Are you sure you want to delete ' + name + '?</p>';
				html += '<button id="modal-btn-cta" class="btn">Delete</button>';
				html += '<button id="modal-btn-cancel" class="btn secondary">Cancel</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		addShippingLine: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'shipping_line',
				method		: 'add',
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,

				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {

					if (data.success) {
						unCodes.clearError();
						//unCodes.errorHTML(data.message, data.level);
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		editShippingLine: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'shipping_line',
				method		: 'edit',
				action		: args.action,
				tid 		: args.tid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						unCodes.clearError();

						if( args.reload ) {
							location.reload();
						}

						// REGENERATE THE FIELD VALUES
						if( data.term ) {
							$('#shipping-line-code').val(data.term.code);
							$('#shipping-line-name').val(data.term.name);
							if (data.term.scac.length > 0) {
								$('#inttra-scac-code').val(data.term.scac.und[0].value);
							}
							$('#shipping-line-tc').val(data.term.tc);
						}

						// TRIGGER UPDATE BUTTON
						$('#modal-btn-cta').click(function(e){
							e.preventDefault();

							shippingLine.editShippingLine(
								modal_dataset,
								{
									tid 	: args.tid,
									action 	: 'update',
									reload 	: true,
								}
							);
						});

						$('#anchorModal').find('.modal-close').click(function(){
							location.reload();
						});
					}
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		deleteShippingLine: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'shipping_line',
				method		: 'delete',
				tid 		: args.tid
			}

			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},
	}

	releaseDepots = {
		addReleaseDepotsHTML: function() {
			var obj = {};
			var html = '<h2>Add new release depot</h2>';
				html += '<p id="modal-error"></p>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="release-depot-name" placeholder="Release depot name *">';
				html += '<label for="release-depot-name">Release depot name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="release-depot-address" placeholder="Release depot address *">';
				html += '<label for="release-depot-address">Release depot address <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				// html += '<div class="input-wrapper form-item">';
				// html += '<input id="release-depot-code" placeholder="Release depot code *">';
				// html += '<label for="release-depot-code">Release depot code <span class="form-required" title="This field is required.">*</span></label>';
				// html += '</div>';

				// html += '<div class="input-wrapper form-item">';
				// html += '<input id="release-depot-name" placeholder="Release depot name *">';
				// html += '<label for="release-depot-name">Release depot name <span class="form-required" title="This field is required.">*</span></label>';
				// html += '</div>';

				// html += '<div class="input-wrapper form-item">';
				// html += '<input id="release-depot-location" placeholder="Location *">';
				// html += '<label for="release-depot-location">Location <span class="form-required" title="This field is required.">*</span></label>';
				// html += '</div>';

				// html += '<div class="input-wrapper form-item">';
				// html += '<input id="release-depot-address" placeholder="Address *">';
				// html += '<label for="release-depot-address">Address <span class="form-required" title="This field is required.">*</span></label>';
				// html += '</div>';

				html += '<button id="modal-btn-cta" class="btn">Add</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		editReleaseDepotsHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Update release depot</h2>';
				html += '<p id="modal-error"></p>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="release-depot-name" placeholder="Release depot name *">';
				html += '<label for="release-depot-name">Release depot name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="release-depot-address" placeholder="Release depot address *">';
				html += '<label for="release-depot-name">Release depot address <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				// html += '<div class="input-wrapper form-item">';
				// html += '<input id="release-depot-code" placeholder="Release depot code *">';
				// html += '<label for="release-depot-code">Release depot code <span class="form-required" title="This field is required.">*</span></label>';
				// html += '</div>';

				// html += '<div class="input-wrapper form-item">';
				// html += '<input id="release-depot-name" placeholder="Release depot name *">';
				// html += '<label for="release-depot-name">Release depot name <span class="form-required" title="This field is required.">*</span></label>';
				// html += '</div>';

				// html += '<div class="input-wrapper form-item">';
				// html += '<input id="release-depot-location" placeholder="Location *">';
				// html += '<label for="release-depot-location">Location <span class="form-required" title="This field is required.">*</span></label>';
				// html += '</div>';

				// html += '<div class="input-wrapper form-item">';
				// html += '<input id="release-depot-address" placeholder="Address *">';
				// html += '<label for="release-depot-address">Address <span class="form-required" title="This field is required.">*</span></label>';
				// html += '</div>';

				html += '<button id="modal-btn-cta" class="btn">Update</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		deleteReleaseDepotsHTML: function(args) {

			var name = (typeof args.name !== 'undefined' && args.name !== '' ) ? '<strong>' + args.name + '</strong>' : 'this release depot';
			var obj = {};
			var html = '<h2>Delete release depot</h2>';
				html += '<p>Are you sure you want to delete ' + name + '?</p>';
				html += '<button id="modal-btn-cta" class="btn">Delete</button>';
				html += '<button id="modal-btn-cancel" class="btn secondary">Cancel</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		addReleaseDepots: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'release_depot',
				method		: 'add',
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,

				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {

					if (data.success) {
						unCodes.clearError();
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		editReleaseDepots: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'release_depot',
				method		: 'edit',
				action		: args.action,
				tid 		: args.tid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						unCodes.clearError();

						if( args.reload ) {
							location.reload();
						}

						// REGENERATE THE FIELD VALUES
						if( data.term ) {
							$('#release-depot-name').val(data.term.name);
							$('#release-depot-address').val(data.term.address);
							// $('#release-depot-code').val(data.term.code);
							// $('#release-depot-name').val(data.term.name);
							// $('#release-depot-location').val(data.term.location);
							// $('#release-depot-address').val(data.term.address);
						}

						// TRIGGER UPDATE BUTTON
						$('#modal-btn-cta').click(function(e){
							e.preventDefault();

							releaseDepots.editReleaseDepots(
								modal_dataset,
								{
									tid 	: args.tid,
									action 	: 'update',
									reload 	: true,
								}
							);
						});

						$('#anchorModal').find('.modal-close').click(function(){
							location.reload();
						});
					}
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		deleteReleaseDepots: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'release_depot',
				method		: 'delete',
				tid 		: args.tid
			}

			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},
	}

	terminals = {
		addTerminalsHTML: function() {
			var obj = {};
			var html = '<h2>Add new terminal</h2>';
				html += '<p id="modal-error"></p>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="terminal-code" placeholder="Terminal code *">';
				html += '<label for="terminal-code">Terminal code <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="terminal-name" placeholder="Terminal name *">';
				html += '<label for="terminal-name">Terminal name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="terminal-address" placeholder="Terminal address *">';
				html += '<label for="terminal-address">Terminal address <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<button id="modal-btn-cta" class="btn">Add</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		editTerminalsHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Update terminal</h2>';
				html += '<p id="modal-error"></p>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="terminal-code" placeholder="Terminal code *">';
				html += '<label for="terminal-code">Terminal code <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="terminal-name" placeholder="Terminal name *">';
				html += '<label for="terminal-name">Terminal name <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<div class="input-wrapper form-item">';
				html += '<input type="text" id="terminal-address" placeholder="Terminal address *">';
				html += '<label for="terminal-address">Terminal address <span class="form-required" title="This field is required.">*</span></label>';
				html += '</div>';

				html += '<button id="modal-btn-cta" class="btn">Update</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		deleteTerminalsHTML: function(args) {

			var name = (typeof args.name !== 'undefined' && args.name !== '' ) ? '<strong>' + args.name + '</strong>' : 'this terminal';
			var obj = {};
			var html = '<h2>Delete terminal</h2>';
				html += '<p>Are you sure you want to delete ' + name + '?</p>';
				html += '<button id="modal-btn-cta" class="btn">Delete</button>';
				html += '<button id="modal-btn-cancel" class="btn secondary">Cancel</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		addTerminals: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'terminal',
				method		: 'add',
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,

				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {

					if (data.success) {
						unCodes.clearError();
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		editTerminals: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');
			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'terminal',
				method		: 'edit',
				action		: args.action,
				tid 		: args.tid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						unCodes.clearError();

						if( args.reload ) {
							location.reload();
						}

						// REGENERATE THE FIELD VALUES
						if( data.term ) {
							$('#terminal-code').val(data.term.code);
							$('#terminal-name').val(data.term.name);
							$('#terminal-address').val(data.term.address);
						}

						// TRIGGER UPDATE BUTTON
						$('#modal-btn-cta').click(function(e){
							e.preventDefault();

							terminals.editTerminals(
								modal_dataset,
								{
									tid 	: args.tid,
									action 	: 'update',
									reload 	: true,
								}
							);
						});

						$('#anchorModal').find('.modal-close').click(function(){
							location.reload();
						});
					}
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		deleteTerminals: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'terminal',
				method		: 'delete',
				tid 		: args.tid
			}

			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},
	}

	var request_change = function(args) {

		var btnCta = document.getElementById('js--request-change');

		//var inputData = getInputFieldVals('.input-wrapper');

		var settings = {
			apiclass	: 'request_change',
			method		: 'edit',
			nid 		: args.nid,
			note 		: $('#js--request-change-note').val(),
		}

		$().customAjax({
			TYPE: "POST",
			AJAX_URL: Drupal.settings.basePath + "anchor/api",
			POST_STRING: settings,
			beforeSend: function() {
				$('#js--request-change-note').css('border', '1px solid #9b9b9b');
				disable_button(btnCta, true);
				btnCta.classList.add('throbber');
			},
			success: function(data) {
				if (data.success) {
					location.reload();
				}
				if (data.error) {
					if (data.error === "No method was set or dosen't exist.") {
						// For some reason node save works but throws error, just gonna supress it.
						location.reload();
					} else {
						$('#js--request-change-note').css('border', '2px solid #fd6275');
					}
				}

				disable_button(btnCta, false);
				btnCta.classList.remove('throbber');
			},
			error: function(data) {
				if (data.error) {
					unCodes.errorHTML(data.error, data.level);
					return;
				}
				unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
				disable_button(btnCta, false);
				btnCta.classList.remove('throbber');
			}
		});
	}

	var getInputFieldVals = function(elem) {
		var inputs = {};
		$(elem).find('input').each(function(i, v) {
			inputs[$(v).attr('id')] = $(v).val();
		});

		$(elem).find('select').each(function(i, v) {
			inputs[$(v).attr('id')] = $(v).val();
		});

		$(elem).find('textarea').each(function(i, v) {
			inputs[$(v).attr('id')] = $(v).val();
		});

		return inputs;
	}


	var invalidFields = function(fields) {
		for (var i in fields) {
			if (!fields[i].valid) {
				$('#' + i).addClass('error');
			} else {
				$('#' + i).removeClass('error');
			}
		}
	}

	var disable_field = function(el, state) {
		if( null == el || typeof el == 'undefined' ) return;

		//remove for AUADL
		// if( state ) {
		// 	el.setAttribute('readonly', true);
		// 	el.setAttribute('disabled', true);
		// 	el.classList.add('disabled');
		// }
		// else{
		// 	el.removeAttribute('readonly');
		// 	el.removeAttribute('disabled');
		// 	el.classList.remove('disabled');
		// }
	}

	var updatePorts = function(method, el) {
		var value = el[0].value;
		var obj = {};
		obj.value = value;
		obj.method = method;
		
		$().customAjax({
			TYPE: "POST",
			AJAX_URL: Drupal.settings.basePath + "portupdate/api",
			POST_STRING: obj,

			onLoad: function() {},

			beforeSend: function() {},

			success: function(data) {
				if (data.success) {
					if (method == 'polUpdate') {
						$('#polName').attr('value',data.port);
					}

					if (method == 'tsUpdate') {
						$('#tsCode').attr('value',data.port);
					}

					if (method == 'podUpdate') {
						$('#podCode').attr('value',data.port);
					}

					if (method == 'fdUpdate') {
						$('#fdCode').attr('value',data.port);
					}
				}

				if (data.error) {
					alert(data.error);
				}
			},

			onEmpty: function() {
				console.log('empty think its alive');
			},

			error: function(data) {
				console.log('error')
			}

		});
	}

})(jQuery, Drupal)


function on (el, ev, fn) {
  let cancelled = false

  const events = ev.split(' ')

  const add = el.on ? () => el.on(ev, fn) : () => el.addEventListener(ev, fn)
  const off = el.off ? () => el.off(ev, fn) : el.removeEventListener(ev, fn)

  let cancel = () => {
    if (cancelled) return
    cancelled = true

    events.forEach(eve => off(eve, fn))

    cancel = () => {}
  }

  events.forEach(eve => add(eve, fn))

  return cancel
}